import { type ReactNode, type PropsWithChildren } from "react";

import * as S from "./OuterFieldV2.styled";

export type OuterFieldV2Props = PropsWithChildren<{
  startSlot?: ReactNode;
  endSlot?: ReactNode;
  buttonSlot?: ReactNode;
  focusElement: () => void;
}>;

function OuterFieldV2(props: OuterFieldV2Props) {
  const { startSlot, endSlot, buttonSlot, focusElement, children } = props;

  function handleClick() {
    focusElement();
  }

  return (
    <S.Container>
      <S.InnerContainer onClick={handleClick}>
        <S.Column01 $buttonSlot={buttonSlot}>
          {startSlot && <S.StartSlotWrapper>{startSlot}</S.StartSlotWrapper>}

          {children}

          {endSlot && <S.EndSlotWrapper>{endSlot}</S.EndSlotWrapper>}
        </S.Column01>

        {buttonSlot && <S.Column02>{buttonSlot}</S.Column02>}
      </S.InnerContainer>
    </S.Container>
  );
}

export default OuterFieldV2;
